<template>
    <div class="fondovista">    
        <div class="container">
            <transition name="slide-fade" appear>
                <b-card>
                    <div class="mt-2">Usuario: <strong>{{ datosSesion.nombres }} {{ datosSesion.apellidos }}</strong></div>
                    <hr>
                    <b-card header-text-variant="white" header-bg-variant="dark" footer-bg-variant="light" footer-border-variant="dark">
                        <div slot="header"><i class="fa fa-comments"></i> Cartelera del Docente</div>
                        <b-card-text>
                            <div v-for="item in publicaciones" :key="item.id">
                                <b-col class="mb-3">
                                    <b-card border-variant="black" header-border-variant="black" header-bg-variant="default" header-text-variant="primary">
                                        <div slot="header"><i class="fas fa-envelope-open-text"></i> {{ item.titulo}}</div>
                                        <b-card-text>{{ item.contenido}}</b-card-text>
                                        <div slot="footer">
                                            <em style="font-size: 12px; color:grey">Publicado por: <strong>{{ item.publicado_por}}</strong> el <strong>{{ item.fecha_publicacion.slice(0,10)}}</strong></em>
                                        </div>
                                    </b-card>
                                </b-col>
                            </div>
                        </b-card-text>
                    </b-card>
                </b-card>
            </transition>
        </div>
    </div>
</template>

<script>
    import axios from "axios"
    import * as CONFIG from '@/assets/config.js'

    export default {
        props: {
            datosSesion: Object
        },
        data() {
        return {
            publicaciones: [],
        }
        },
        methods: {
        async cargarDatos() {
            await axios
            .get(CONFIG.ROOT_PATH + "publicaciones/docentes")
            .then(response => {
            if (response.data.error){
                this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
            } else{
                this.publicaciones = response.data.datos
            }
            })
            .catch(err => {
            if (err.message === "Network Error")
                this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
            else
                this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
            });
        },
        mensajeEmergente(variante, titulo, contenido) {
            this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false });
        }
        },
        beforeMount() {
        this.cargarDatos()
        }
    }
</script>